import { BRAND } from '@/constants';

const WHATSAPP_MESSAGE =
  'Bonjour, je souhaite prendre rendez-vous pour une séance de cupping thérapie.';

export default function WhatsAppButton() {
  const whatsappUrl = `https://wa.me/${BRAND.phoneWhatsApp}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="nofollow noopener"
      aria-label="Écrire sur WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 flex items-center justify-center bg-[#25d366] text-white rounded-full shadow-[0_8px_24px_rgba(4,22,17,.3)] text-[26px] transition-transform duration-300 hover:scale-110"
    >
      <i className="ri-whatsapp-line"></i>
    </a>
  );
}
